/** Ordre canonique des étapes — l'index sert d'`index` de tirage RNG (§3.4). */
export const ATELIER_STAGES = [
    "ecriture",
    "tournage",
    "montage",
    "miniature",
    "promotion",
];
/** Paliers d'abonnés (PLAN §4.13) + paliers post-1M (PLAN §4.13 « Après la rue »). */
export const PALIERS = [100, 1_000, 10_000, 100_000, 500_000, 1_000_000];
export const PALIERS_POST_1M = [2_000_000, 5_000_000, 10_000_000];
/** La version qu'écrit le moteur d'aujourd'hui (`initialState`). */
export const SCHEMA_VERSION_COURANTE = 2;
/** ⟦A-81⟧ La famille d'une ligne, défaut compris — le seul endroit où l'absence se lit. */
export function familleDuLog(entree) {
    return entree.famille ?? "evenement";
}
/**
 * Erreur typée levée par `resolve` — n'a consommé ni `turn` ni tirage (§2.3 pas 1).
 * `details` porte le contexte lisible par l'API (montant manquant, id fautif…).
 */
export class InvalidAction extends Error {
    code;
    details;
    constructor(code, details = {}) {
        super(code);
        this.name = "InvalidAction";
        this.code = code;
        this.details = details;
    }
}
/**
 * Seuil d'éligibilité evergreen d'un sujet.
 *
 * Arbitrage **A26** (nouveau, à valider en M1.21) : SPEC-MOTEUR §6.1 attend un booléen
 * `sujet.evergreen_potential`, SPEC-CONTENU §3.4 livre `potentiel_evergreen: 0-100` avec
 * le seuil « ≥ 60 ». Défaut appliqué : **CONTENU** (c'est lui qui tague les sujets — même
 * logique que A23), le booléen du moteur devient `potentiel_evergreen >= 60`.
 */
export const SEUIL_EVERGREEN = 60;
//# sourceMappingURL=types.js.map